var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BButton, BDropdown, BDropdownItem } from "bootstrap-vue";
import { computed } from "vue";
import { useConfirmDialog } from "@/composables/confirmDialog";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Options',
    props: {
        isNewTempWorkflow: { type: Boolean },
        hasChanges: { type: Boolean },
        hasInvalidConnections: { type: Boolean },
        requiredReindex: { type: Boolean }
    },
    emits: ["onAttributes", "onSave", "onCreate", "onReport", "onSaveAs", "onLayout", "onLint", "onUpgrade", "onDownload", "onRun"],
    setup(__props, { emit }) {
        const props = __props;
        const { confirm } = useConfirmDialog();
        const saveHover = computed(() => {
            if (props.isNewTempWorkflow) {
                return "Create a new workflow";
            }
            else if (!props.hasChanges) {
                return "Workflow has no changes";
            }
            else if (props.hasInvalidConnections) {
                return "Workflow has invalid connections, review and remove invalid connections";
            }
            else {
                return "Save Workflow";
            }
        });
        function emitSaveOrCreate() {
            if (props.isNewTempWorkflow) {
                emit("onCreate");
            }
            else {
                emit("onSave");
            }
        }
        function onSave() {
            return __awaiter(this, void 0, void 0, function* () {
                if (props.hasInvalidConnections) {
                    console.log("getting confirmation");
                    const confirmed = yield confirm(`Workflow has invalid connections. You can save the workflow, but it may not run correctly.`, {
                        id: "save-workflow-confirmation",
                        okTitle: "Save Workflow",
                    });
                    if (confirmed) {
                        emitSaveOrCreate();
                    }
                }
                else {
                    emitSaveOrCreate();
                }
            });
        }
        return { __sfc: true, emit, props, confirm, saveHover, emitSaveOrCreate, onSave, BButton, BDropdown, BDropdownItem };
    }
});
